import { useMemo } from 'react';
import { getRandomAvatarColor } from '../utils/color.mjs';

function useRandomAvatarColor({
  key,
  colorScheme
}) {
  return useMemo(
    () => getRandomAvatarColor({ key, colorScheme }),
    [key, colorScheme]
  );
}

export { useRandomAvatarColor };
//# sourceMappingURL=useRandomAvatarColor.mjs.map
